const mapping: Record<string, string> = {
  id: 's=>s.Id',
  rowAlias: 's=>s.RowAlias',
  numberAlias: 's=>s.numberAlias',
  blockId: 's=>s.blockId',
}

export const mapSortSeatParam = (key: string) => mapping[key]
